module.exports = __webpack_public_path__ + "assets/img/yzzx_anru_video.7220ae5c.png";